import { Link } from "react-router-dom";

const menuLinks = [
  { label: "Anasayfa", path: "/" },
  { label: "Kurumsal", path: "/kurumsal" },
  { label: "Hizmetlerimiz", path: "/hizmetlerimiz" },
  { label: "Hizmet Bölgelerimiz", path: "/hizmet-bolgelerimiz" },
  { label: "Sıkça Sorulan Sorular", path: "/sikca-sorulan-sorular" },
  { label: "İletişim", path: "/iletisim" },
];

const serviceLinks = [
  { label: "Daire Temizliği", path: "/hizmetlerimiz/daire-temizligi" },
  { label: "Bina ve Site Temizliği", path: "/hizmetlerimiz/bina-ve-site-temizligi" },
  { label: "Apartman Temizliği", path: "/hizmetlerimiz/apartman-temizligi" },
  { label: "İnşaat Sonrası Temizlik", path: "/hizmetlerimiz/insaat-sonrasi-temizlik" },
  { label: "Koltuk Yıkama", path: "/hizmetlerimiz/koltuk-yikama" },
  { label: "Halı Yıkama", path: "/hizmetlerimiz/hali-yikama" },
  { label: "Kuru Temizleme ve Ütü", path: "/hizmetlerimiz/kuru-temizleme-ve-utu" },
  { label: "İlaçlama", path: "/hizmetlerimiz/ilaclama" },
];

export default function Footer() {
  return (
    <footer className="bg-primary-900 text-background-50">
      <div className="w-full px-4 md:px-6 lg:px-10 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="sm:col-span-2 lg:col-span-1">
            <div className="flex items-center gap-3 mb-4">
              <img
                src="/assets/images/logo.png"
                alt="Day Temizlik Adana Logo"
                className="h-10 w-auto"
              />
              <span className="font-heading text-lg font-semibold">Day Temizlik Adana</span>
            </div>
            <p className="text-sm text-foreground-300 leading-relaxed">
              Sarıçam ve Adana genelinde profesyonel temizlik, bina ve site temizliği, koltuk yıkama, halı yıkama, inşaat sonrası temizlik, ilaçlama ve yönetim çözümleri sunar.
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold mb-4">Menü</h4>
            <ul className="space-y-2">
              {menuLinks.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-sm text-foreground-300 hover:text-background-50 transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold mb-4">Hizmetlerimiz</h4>
            <ul className="space-y-2">
              {serviceLinks.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-sm text-foreground-300 hover:text-background-50 transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold mb-4">İletişim</h4>
            <ul className="space-y-3">
              <li className="flex items-start gap-2">
                <i className="ri-phone-line w-4 h-4 flex items-center justify-center mt-0.5 text-accent-400"></i>
                <a href="tel:05539591940" className="text-sm text-foreground-300 hover:text-background-50 transition-colors">
                  0553 959 19 40
                </a>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-map-pin-line w-4 h-4 flex items-center justify-center mt-0.5 text-accent-400"></i>
                <span className="text-sm text-foreground-300">
                  Güzelyalı, 81201. Sk. Kardelen Sitesi A Blok No 20-a, 01170 Çukurova/Adana
                </span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-time-line w-4 h-4 flex items-center justify-center mt-0.5 text-accent-400"></i>
                <span className="text-sm text-foreground-300">7/24 Hizmet</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-primary-700/50 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-400">
            &copy; {new Date().getFullYear()} Day Temizlik Adana. Tüm hakları saklıdır.
          </p>
          <div className="flex items-center gap-4">
            <a href="https://wa.me/905539591940" target="_blank" rel="noopener noreferrer" className="text-sm text-foreground-300 hover:text-background-50 transition-colors" aria-label="WhatsApp">
              <i className="ri-whatsapp-line w-5 h-5 flex items-center justify-center"></i>
            </a>
            <a href="tel:05539591940" className="text-sm text-foreground-300 hover:text-background-50 transition-colors" aria-label="Telefon">
              <i className="ri-phone-line w-5 h-5 flex items-center justify-center"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}